import { filterSelectTriggerClassName } from "@/components/dashboard/active-filters-bar";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import type { RegistrantOption } from "@/hooks/use-registrant-dashboard-data";

const ALL_REGISTRANTS_VALUE = "__all__";

interface RegistrantFilterProps {
  registrantOptions: RegistrantOption[];
  selectedRegistrantAccountId: string | null;
  onSelectedRegistrantAccountIdChange: (id: string | null) => void;
}

export function RegistrantFilter({
  registrantOptions,
  selectedRegistrantAccountId,
  onSelectedRegistrantAccountIdChange,
}: RegistrantFilterProps) {
  const options = [
    { value: ALL_REGISTRANTS_VALUE, label: "All registrants" },
    ...registrantOptions,
  ];

  const value = selectedRegistrantAccountId
    ? [selectedRegistrantAccountId]
    : [ALL_REGISTRANTS_VALUE];

  const handleChange = (v: string[]) => {
    const id = v[0];
    onSelectedRegistrantAccountIdChange(
      id && id !== ALL_REGISTRANTS_VALUE ? id : null,
    );
  };

  return (
    <div className="w-full shrink-0 md:w-64 md:max-w-full">
      <Label htmlFor="registrant-filter" className="mb-2 block font-bold">
        Filter by Registrant
      </Label>
      <Select
        options={options}
        value={value}
        onValueChange={handleChange}
        multiple={false}
        placeholder="All registrants"
        searchPlaceholder="Search registrants..."
        emptyMessage="No registrant found."
        buttonVariant="default"
        className={filterSelectTriggerClassName(
          Boolean(selectedRegistrantAccountId),
        )}
      />
    </div>
  );
}
